import { render, staticRenderFns } from "./InspectionsSummary.vue?vue&type=template&id=f5ea87a0&scoped=true"
import script from "./InspectionsSummary.vue?vue&type=script&lang=js"
export * from "./InspectionsSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5ea87a0",
  null
  
)

export default component.exports